import "./styles.css";
import { initializeAnalytics } from "./analytics";
import { initializeConsent } from "./consent";
import { initializePublicNavigation } from "./public-navigation";

const disposeConsent = initializeConsent(document, window);
const disposeAnalytics = initializeAnalytics(document, window);
const disposeNavigation = initializePublicNavigation(document, window);
const year = document.getElementById("copyright-year");
if (year) year.textContent = String(new Date().getFullYear());

if (import.meta.hot)
  import.meta.hot.dispose(() => {
    disposeNavigation();
    disposeAnalytics();
    disposeConsent();
  });
